import { ColumnDef } from "@tanstack/react-table";

import SmsSimulatorRulesTableActionsMenu from "containers/sms-simulator/sms-simulator-rules/components/sms-simulator-rules-table-actions-menu";

import { SmsSimulatorRuleAttributes } from "containers/sms-simulator/sms-simulator.types";

interface SmsSimulatorRulesTableActionsProps {
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
}

const headerStyles = "text-gray-600 font-bold text-sm leading-5";

export const createSmsSimulatorRulesTableColumns = ({
  onEdit,
  onDelete,
}: SmsSimulatorRulesTableActionsProps): ColumnDef<SmsSimulatorRuleAttributes>[] => [
  {
    id: "description",
    header: "Rules",
    accessorKey: "description",
    cell: ({ row }) => <div className="py-1">{row.original.description}</div>,
    size: 600,
    meta: {
      headerClassName: `${headerStyles} pl-2`,
      className: "py-1 pl-2",
    },
  },

  {
    id: "action",
    header: "Action",
    enableSorting: false,
    cell: ({ row }) => (
      <SmsSimulatorRulesTableActionsMenu
        item={{ itemName: row.original.description, itemId: row.original.id }}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    ),
    size: 80,
    meta: {
      headerClassName: headerStyles,
      className: "py-1",
      isHeaderCentered: true,
    },
  },
];
